// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBorderLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PBorderLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PBorderLeftOutlined = function PBorderLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBorderLeftOutlinedSvg
  }));
};

PBorderLeftOutlined.displayName = 'PBorderLeftOutlined';
export default React.forwardRef(PBorderLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBorderLeftOutlined.js
// module id = 3247
// module chunks = 0